import React from "react";

function BankOfGeorgia() {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2335_6943"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="24"
      >
        <g clip-path="url(#clip0_2335_6943)">
          <path
            d="M35.2001 -4.80078H-3.19995V26.5757H35.2001V-4.80078Z"
            fill="white"
          />
        </g>
      </mask>
      <g mask="url(#mask0_2335_6943)">
        <path
          d="M30.6404 5.39847C30.1486 4.71458 28.85 2.84348 27.9893 2.14613C27.267 1.56982 26.4198 1.15871 25.3575 1.22595C23.521 1.34313 21.9976 2.88766 21.0313 4.04029C20.2802 4.93358 17.9826 6.36092 15.5294 7.00839C13.6756 7.49634 11.5855 7.24852 9.92766 7.12942C9.01132 7.0641 8.1699 6.99687 7.44758 7.03337C4.84264 7.164 3.29043 9.07544 3.3519 11.2885C3.4153 13.5361 4.95982 15.5801 4.95982 17.6894C4.95982 19.3435 3.61509 20.0735 2.68722 20.0735C1.57877 20.0735 1.50577 19.622 1.16767 19.622C1.03127 19.622 0.871826 19.7354 0.871826 19.9159C0.871826 20.475 2.24154 21.0071 3.01956 21.0071C5.09814 21.0071 5.96261 19.524 5.96261 19.524C5.96261 19.524 6.4909 21.0609 8.54066 21.0609C10.1736 21.0609 10.8805 20.279 10.8805 19.6278C10.8805 19.111 10.6365 18.9208 10.4214 18.6749C8.69819 17.0689 8.10458 15.947 8.39466 14.8463C8.6905 13.7225 9.87387 12.9771 10.7768 12.9905C10.7768 12.9905 9.53384 13.684 9.27258 14.9462C9.00364 16.241 10.4002 17.4993 10.7652 17.6356C10.7652 17.6356 11.1341 17.6356 11.2378 17.626C12.1599 17.5434 12.4557 17.1093 12.4557 16.6847C12.4557 16.0758 11.7431 16.118 11.7431 15.1171C11.7431 14.3603 12.1618 14.1124 12.5326 14.1124C12.9321 14.1124 14.4459 14.2584 16.2805 14.4467C16.8934 14.5082 18.4206 15.0999 18.4206 17.4724V18.3253C18.4206 19.7719 19.0027 21.5604 21.5596 21.5604C23.2962 21.5604 24.2702 20.5921 24.2702 19.8929C24.2702 19.4357 23.8706 19.2359 23.6727 18.9612C23.0945 18.1505 23.3788 17.0228 23.3788 17.0228H23.3903C23.6343 17.1016 23.9129 17.1477 24.2395 17.1477C25.5189 17.1477 26.1202 16.6405 26.1202 16.0335C26.1202 15.3246 25.1616 15.3285 25.0617 14.7041C24.9368 13.9261 25.1443 10.4817 26.4832 8.57789L27.5417 9.05431C27.6993 9.12539 27.8856 9.08313 27.9951 8.95057L30.6231 5.87297C30.7345 5.7385 30.7422 5.54639 30.6404 5.40232"
          fill="#FF6022"
        />
        <path
          d="M5.93341 13.0015C5.42049 12.4886 5.10352 11.7797 5.10352 10.9998C5.10352 9.43602 6.50012 7.94337 8.06385 7.93376C9.65256 7.92415 11.9021 8.33526 13.9288 8.16429C14.4283 10.5387 16.1438 12.1428 17.5865 13.1936C16.7681 12.9035 14.1439 10.9825 12.6667 10.1641C10.3153 8.85971 7.89288 8.60036 6.6538 9.74147C5.58762 10.7231 5.73554 12.1754 5.93341 12.9996"
          fill="white"
        />
        <path
          d="M22.658 16.1034V16.0938C22.658 16.0938 21.3191 17.3674 21.9319 19.6804C21.5592 20.0434 20.7043 19.9051 20.3374 19.8494C20.5756 20.1529 22.4121 20.8215 23.0615 19.7169C21.8089 18.7467 22.6311 16.2666 22.658 16.1053"
          fill="white"
        />
        <path
          d="M28.0005 4.28071C27.9122 4.76866 27.3647 5.07987 26.7749 4.97229C26.1851 4.86471 25.7817 4.38253 25.872 3.89458C25.9604 3.40471 26.5079 3.09542 27.0996 3.203C27.6855 3.30866 28.0908 3.79276 28.0005 4.28071Z"
          fill="white"
        />
        <path
          d="M25.5483 8.37223C23.2161 8.23392 21.5237 6.84692 21.0473 5.64042C20.9378 5.36379 21.1068 5.17553 21.2739 5.09868C21.4392 5.02376 21.7158 5.06987 21.8195 5.33689C22.4765 7.01597 23.8078 7.88044 25.5483 8.37415"
          fill="white"
        />
        <path
          d="M24.7293 10.2598C21.5557 10.1733 19.846 8.90927 18.9623 7.0593C18.8682 6.86335 18.922 6.61361 19.1678 6.50411C19.4137 6.39454 19.6308 6.50412 19.7134 6.71351C20.526 8.78056 22.6815 9.99082 24.7293 10.2598Z"
          fill="white"
        />
        <path
          d="M16.5916 8.10032C17.8441 11.0799 20.6392 12.4496 24.1375 12.2613C20.9082 12.0154 18.4223 10.5247 17.3581 7.80063C17.2582 7.54321 17.0449 7.47982 16.849 7.54129C16.6511 7.60084 16.4725 7.82177 16.5916 8.10224"
          fill="white"
        />
        <path
          d="M28.8796 4.39062C28.8796 4.39062 28.9161 5.53941 27.6021 6.11957C26.2977 6.69596 25.1777 5.84486 25.122 5.8026C25.0394 5.74112 24.9875 5.64315 24.9875 5.53365C24.9875 5.34731 25.1374 5.19747 25.3237 5.19747C25.4102 5.19747 25.4889 5.23012 25.5485 5.28199C25.61 5.3377 26.3323 6.07154 27.5233 5.78147C28.7125 5.48947 28.8834 4.39255 28.8834 4.39255"
          fill="white"
        />
        <path
          d="M24.9794 3.71969C24.9564 3.87913 24.8181 4.004 24.6509 4.004C24.4665 4.004 24.3186 3.85608 24.3186 3.67166C24.3186 3.639 24.3244 3.60634 24.3321 3.57753C24.3589 3.48724 24.6874 2.41914 25.8881 2.14058C27.0638 1.86779 27.8437 2.45564 27.8437 2.45564C27.8437 2.45564 26.9812 1.96961 25.9899 2.41913C25.1831 2.76877 24.9929 3.61787 24.9775 3.72161"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2335_6943">
          <rect width="32" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BankOfGeorgia;
